/**
 * 系谱图 — admin binary placement genealogy (网体系谱 + 全球玩家表).
 */
import { Tabs } from 'antd';
import { AdminGenealogyDrillViewer } from '../../components/AdminGenealogyDrillViewer';
import { AdminGlobalPlayersTable } from './AdminGlobalPlayersTable';
import { AdminOutOfNetworkPlayersTable } from './AdminOutOfNetworkPlayersTable';
import { BinaryTreePage } from './BinaryTreePage';

export function GenealogyChartPage() {
  return (
    <div>
      <h2 style={{ marginTop: 0 }}>系谱图</h2>
      <Tabs
        items={[
          {
            key: 'global',
            label: '全球玩家(表)',
            children: <AdminGlobalPlayersTable />,
          },
          {
            key: 'out',
            label: '非全球玩家',
            children: <AdminOutOfNetworkPlayersTable />,
          },
          {
            key: 'drill',
            label: '网体系谱',
            children: <AdminGenealogyDrillViewer />,
          },
          {
            key: 'tree',
            label: '树形预览',
            children: <BinaryTreePage embedded />,
          },
        ]}
        defaultActiveKey="global"
      />
    </div>
  );
}
